













































































































































import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import Uploader from '@/modules/shared/components/shared/form/Uploader.vue'
import QUploader from 'quasar/src/components/uploader/QUploader.js';

@Component
export default class AvatarUploader extends Uploader {
  @Prop({ default: 'لوگو' }) readonly type!: string
  max = 1

  //show addButton (over-ridden)
  showHeader(filesLength: number) {
    return false //avatar maxFile is 1 so false
  }

  pickFiles(vm: QUploader & { files: File[] }) {
    vm.pickFiles()
  }

  addFile(files: File & { __img?: HTMLImageElement }[]) {
    this.fileChange()
  }

  setFiles() {
    if (typeof this.value !== 'string') {
      ;(this.$refs.uploader as any).files = this.value
    }
  }

  get files() {
    return this.value
  }
}
